var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66683 2.99996C4.66683 1.80829 3.69183 0.833292 2.50016 0.833292C1.3085 0.833292 0.333496 1.80829 0.333496 2.99996C0.333496 4.19163 1.3085 5.16663 2.50016 5.16663C3.69183 5.16663 4.66683 4.19163 4.66683 2.99996ZM6.8335 2.99996C6.8335 4.19163 7.8085 5.16663 9.00016 5.16663C10.1918 5.16663 11.1668 4.19163 11.1668 2.99996C11.1668 1.80829 10.1918 0.833292 9.00016 0.833292C7.8085 0.833292 6.8335 1.80829 6.8335 2.99996ZM13.3335 2.99996C13.3335 4.19163 14.3085 5.16663 15.5002 5.16663C16.6918 5.16663 17.6668 4.19163 17.6668 2.99996C17.6668 1.80829 16.6918 0.833292 15.5002 0.833292C14.3085 0.833292 13.3335 1.80829 13.3335 2.99996Z",
    fill: "#85929B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.1af10e9d94e8bedb1db3bc1590ecc9c6.svg";
export { ForwardRef as ReactComponent };